import { render, staticRenderFns } from "./NavMenuLogin.vue?vue&type=template&id=63b004ca&scoped=true&"
import script from "./NavMenuLogin.vue?vue&type=script&lang=ts&"
export * from "./NavMenuLogin.vue?vue&type=script&lang=ts&"
import style0 from "./NavMenuLogin.vue?vue&type=style&index=0&id=63b004ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63b004ca",
  null
  
)

export default component.exports